import { cloneInstanceClass } from '~/helpers/cloneInstanceClass'
import { TransitionAsset } from '~/models/Asset'

export const getCopiedAssetsTransitions = (copiedAssets, allAssets) => {
  const resultTransitions = []
  const copiedAssetsIds = copiedAssets.map(asset => asset.id)
  const transitions = allAssets.filter(asset => asset instanceof TransitionAsset)
  transitions.forEach(transition => {
    const right = copiedAssetsIds.includes(transition.rightVideoAssetId)
    const left = copiedAssetsIds.includes(transition.leftVideoAssetId)
    if ((transition.isMountBetween && right && left)
    || (transition.isMountIn && right)
    || (transition.isMountOut && left)) {
      const newTransition = cloneInstanceClass(transition)
      newTransition.selected = false
      resultTransitions.push(newTransition)
    }
  })
  return resultTransitions
}
